//frontend/src/components/admin/CompanyModal.jsx
import { useState, useEffect } from 'react';
import ImageUpload from '../common/ImageUpload';
import { companyAPI, systemBankAPI } from '../../services/api';

const CompanyModal = ({ company, onClose }) => {
  const [formData, setFormData] = useState({
  company_name: '',
  entity_type: 'company',  // 'company' = Байгууллага, 'individual' = Хувь хүн
  register_number: '',
  email: '',
  phone: '',
  address: '',
  commission_type: 'per_delivery',
  commission_value: 1000,
  billing_cycle: 'daily',
  status: 'active',
  system_bank_account_id: '',
  max_warehouses: 1,
  // ============================================
  // ШИНЭ: Гэрээний тохиргоо
  // ============================================
  pricing_model: 'per_delivery',
  monthly_fee: 0,
  // Туршилтын хугацаа
  trial_days: 0,
  trial_preset: '0', // UI-д хэрэглэх (0, 7, 14, 30, custom)
  // Үнэгүй хүргэлт
  free_delivery_count: 0,
  // Гэрээний хугацаа
  contract_start_date: '',
  contract_end_date: '',
  auto_renew: false,
  // Хямдрал & Төлбөрийн нөхцөл
  discount_percent: 0,
  payment_terms_days: 7,
  credit_limit: 0,
  contract_notes: '',
  // Admin data
  admin_full_name: '',
  admin_email: '',
  admin_phone: '',
});

  const [logoFile, setLogoFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [credentials, setCredentials] = useState(null);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [loadingBanks, setLoadingBanks] = useState(false);

  // Fetch bank accounts
  useEffect(() => {
    const fetchBankAccounts = async () => {
      setLoadingBanks(true);
      try {
        const response = await systemBankAPI.getActive();
        if (response.data.success) {
          setBankAccounts(response.data.data);
        }
      } catch (err) {
        console.error('Банкны данс татахад алдаа:', err);
      } finally {
        setLoadingBanks(false);
      }
    };
    fetchBankAccounts();
  }, []);

  useEffect(() => {
  if (company) {
    // Trial preset тодорхойлох
    let trialPreset = '0';
    const trialDays = company.trial_days || 0;
    if (trialDays === 7) trialPreset = '7';
    else if (trialDays === 14) trialPreset = '14';
    else if (trialDays === 30) trialPreset = '30';
    else if (trialDays > 0) trialPreset = 'custom';

     setFormData({
      company_name: company.company_name || '',
      entity_type: company.entity_type || 'company',
      register_number: company.register_number || '',
      email: company.email || '',
      phone: company.phone || '',
      address: company.address || '',
      commission_type: company.commission_type || 'per_delivery',
      commission_value: company.commission_value || 1000,
      billing_cycle: company.billing_cycle || 'daily',
      status: company.status || 'active',
      system_bank_account_id: company.system_bank_account_id || '',
      max_warehouses: company.max_warehouses || 1,
      // ============================================
      // ШИНЭ: Гэрээний тохиргоо
      // ============================================
      pricing_model: company.pricing_model || 'per_delivery',
      monthly_fee: company.monthly_fee || 0,
      trial_days: trialDays,
      trial_preset: trialPreset,
      free_delivery_count: company.free_delivery_count || 0,
      contract_start_date: company.contract_start_date || '',
      contract_end_date: company.contract_end_date || '',
      auto_renew: company.auto_renew || false,
      discount_percent: company.discount_percent || 0,
      payment_terms_days: company.payment_terms_days || 7,
      credit_limit: company.credit_limit || 0,
      contract_notes: company.contract_notes || '',
      // Admin
      admin_full_name: '',
      admin_email: '',
      admin_phone: '',
    });
  }
}, [company]);

  // Real-time validation
  const validateField = (name, value) => {
    const newErrors = { ...errors };

    switch (name) {
      case 'company_name':
        if (!value.trim()) {
          newErrors.company_name = 'Компанийн нэр оруулна уу';
        } else if (value.length < 2) {
          newErrors.company_name = 'Хамгийн багадаа 2 тэмдэгт';
        } else {
          delete newErrors.company_name;
        }
        break;

      case 'register_number':
        if (value && value.trim()) {
          const entityType = formData.entity_type;
          if (entityType === 'company') {
            // Байгууллага: 7 оронтой тоо
            if (!/^\d{7}$/.test(value)) {
              newErrors.register_number = 'Байгууллагын РД 7 оронтой тоо байх ёстой';
            } else {
              delete newErrors.register_number;
            }
          } else {
            // Хувь хүн: 2 үсэг + 8 тоо (жнь: ВК78120222)
            if (!/^[А-Яа-яӨөҮүЁё]{2}\d{8}$/i.test(value)) {
              newErrors.register_number = 'Хувь хүний РД: 2 үсэг + 8 тоо (жнь: ВК78120222)';
            } else {
              delete newErrors.register_number;
            }
          }
        } else {
          delete newErrors.register_number;
        }
        break;

      case 'phone':
        if (!value.trim()) {
          newErrors.phone = 'Утасны дугаар оруулна уу';
        } else if (!/^\d{8}$/.test(value.replace(/\s/g, ''))) {
          newErrors.phone = '8 оронтой тоо оруулна уу';
        } else {
          delete newErrors.phone;
        }
        break;

      case 'email':
        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors.email = 'И-мэйл буруу байна';
        } else {
          delete newErrors.email;
        }
        break;

      case 'commission_value':
        const numValue = parseFloat(value);
        if (!value || numValue <= 0) {
          newErrors.commission_value = 'Комисс 0-ээс их байх ёстой';
        } else if (numValue > 10000000) {
          newErrors.commission_value = 'Комисс хэт өндөр байна';
        } else {
          delete newErrors.commission_value;
        }
        break;

      case 'admin_phone':
        if (!company && value && !/^\d{8}$/.test(value.replace(/\s/g, ''))) {
          newErrors.admin_phone = '8 оронтой тоо оруулна уу';
        } else {
          delete newErrors.admin_phone;
        }
        break;

      default:
        break;
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation
    validateField(name, value);
  };

  // Туршилтын хугацаа сонголт
  const handleTrialPresetChange = (e) => {
    const preset = e.target.value;
    let days = 0;
    
    if (preset === '7') days = 7;
    else if (preset === '14') days = 14;
    else if (preset === '30') days = 30;
    else if (preset === 'custom') days = formData.trial_days || 0;
    
    setFormData(prev => ({
      ...prev,
      trial_preset: preset,
      trial_days: days
    }));
  };

  // Checkbox handler
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleLogoChange = (file) => {
    setLogoFile(file);
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields
    if (!formData.company_name.trim()) {
      newErrors.company_name = 'Компанийн нэр оруулна уу';
    }
     // РД заавал биш, гэхдээ оруулсан бол формат шалгах
    if (formData.register_number && formData.register_number.trim()) {
      if (formData.entity_type === 'company') {
        if (!/^\d{7}$/.test(formData.register_number)) {
          newErrors.register_number = 'Байгууллагын РД 7 оронтой тоо байх ёстой';
        }
      } else {
        if (!/^[А-Яа-яӨөҮүЁё]{2}\d{8}$/i.test(formData.register_number)) {
          newErrors.register_number = 'Хувь хүний РД: 2 үсэг + 8 тоо (жнь: ВК78120222)';
        }
      }
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Утасны дугаар оруулна уу';
    }
    if (!formData.commission_value || formData.commission_value <= 0) {
      newErrors.commission_value = 'Комисс оруулна уу';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      const data = new FormData();

      // Company data
      data.append('company_name', formData.company_name);
      data.append('entity_type', formData.entity_type);
      if (formData.register_number) {
        data.append('register_number', formData.register_number);
      }
      data.append('phone', formData.phone);
      if (formData.email) data.append('email', formData.email);
      if (formData.address) data.append('address', formData.address);
      data.append('commission_type', formData.commission_type);
      data.append('commission_value', formData.commission_value);
      data.append('billing_cycle', formData.billing_cycle);
      data.append('status', formData.status);
      
      // Bank account
      if (formData.system_bank_account_id) {
        data.append('system_bank_account_id', formData.system_bank_account_id);
      }

      // Max warehouses
      data.append('max_warehouses', formData.max_warehouses);

      // ============================================
      // ШИНЭ: Гэрээний тохиргоо
      // ============================================
      data.append('pricing_model', formData.pricing_model);
      data.append('monthly_fee', formData.monthly_fee);
      data.append('trial_days', formData.trial_days);
      data.append('free_delivery_count', formData.free_delivery_count);
      
      if (formData.contract_start_date) {
        data.append('contract_start_date', formData.contract_start_date);
      }
      if (formData.contract_end_date) {
        data.append('contract_end_date', formData.contract_end_date);
      }
      data.append('auto_renew', formData.auto_renew);
      data.append('discount_percent', formData.discount_percent);
      data.append('payment_terms_days', formData.payment_terms_days);
      data.append('credit_limit', formData.credit_limit);
      if (formData.contract_notes) {
        data.append('contract_notes', formData.contract_notes);
      }

      // Logo
      if (logoFile) {
        data.append('logo', logoFile);
      }

      // Admin data (only for new company)
      if (!company) {
        if (formData.admin_full_name) {
          data.append('admin[full_name]', formData.admin_full_name);
        }
        if (formData.admin_email) {
          data.append('admin[email]', formData.admin_email);
        }
        if (formData.admin_phone) {
          data.append('admin[phone]', formData.admin_phone);
        }
      }

      let response;
      if (company) {
        response = await companyAPI.update(company.id, data);
        alert('✅ Компани амжилттай шинэчлэгдлээ!');
        onClose(true);
      } else {
        response = await companyAPI.create(data);

        // Show credentials modal
        if (response.data.data?.credentials) {
          setCredentials(response.data.data.credentials);
        } else {
          alert('✅ Компани амжилттай үүслээ!');
          onClose(true);
        }
      }
    } catch (error) {
      console.error('Submit error:', error);
      const errorMessage = error.response?.data?.message || 'Алдаа гарлаа';
      setErrors({ submit: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  // Credentials Modal
  if (credentials) {
    return (
      <div className="modal-overlay">
        <div className="modal-content max-w-md">
          <div className="p-6">
            <div className="text-center mb-6">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl">✅</span>
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Компани үүслээ!
              </h2>
              <p className="text-gray-600">
                Админы нэвтрэх мэдээллийг хадгална уу
              </p>
            </div>

            <div className="bg-blue-50 rounded-xl p-6 mb-6 border-2 border-blue-200">
              <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>🔐</span>
                <span>Нэвтрэх мэдээлэл:</span>
              </h3>
              <div className="space-y-3">
                <div className="bg-white rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">Нэвтрэх нэр:</p>
                  <p className="font-mono font-bold text-lg text-gray-900">
                    {credentials.username}
                  </p>
                </div>
                <div className="bg-white rounded-lg p-3">
                  <p className="text-xs text-gray-500 mb-1">Нууц үг:</p>
                  <p className="font-mono font-bold text-lg text-gray-900">
                    {credentials.password}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-yellow-800">
                ⚠️ {credentials.message}
              </p>
            </div>

            <button
              onClick={() => onClose(true)}
              className="btn btn-primary w-full justify-center"
            >
              Ойлголоо
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Main Form Modal
  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-3xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-900">
              {company ? 'Компани засах' : 'Шинэ компани нэмэх'}
            </h2>
            <button
              onClick={() => onClose(false)}
              className="text-gray-400 hover:text-gray-600 transition"
              disabled={loading}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6">
          {/* Error Message */}
          {errors.submit && (
            <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-sm text-red-800">❌ {errors.submit}</p>
            </div>
          )}

          <div className="space-y-6">
            {/* Logo Upload */}
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                Компанийн лого
              </label>
              <ImageUpload
                value={company?.logo_url ? `http://localhost:5000${company.logo_url}` : null}
                onChange={handleLogoChange}
                disabled={loading}
              />
              <p className="mt-2 text-xs text-gray-500">
                PNG эсвэл JPG, 500x500px, 4MB хүртэл
              </p>
            </div>

             {/* Company Info */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>🏢</span>
                <span>{formData.entity_type === 'individual' ? 'Хувь хүний мэдээлэл' : 'Байгууллагын мэдээлэл'}</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Хувь хүн / Байгууллага сонголт */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Төрөл <span className="text-red-500">*</span>
                  </label>
                  <div className="flex gap-4">
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="entity_type"
                        value="company"
                        checked={formData.entity_type === 'company'}
                        onChange={handleChange}
                        className="w-4 h-4 text-blue-600"
                        disabled={loading}
                      />
                      <span className="text-sm">🏢 Байгууллага</span>
                    </label>
                    <label className="flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        name="entity_type"
                        value="individual"
                        checked={formData.entity_type === 'individual'}
                        onChange={handleChange}
                        className="w-4 h-4 text-blue-600"
                        disabled={loading}
                      />
                      <span className="text-sm">👤 Хувь хүн</span>
                    </label>
                  </div>
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {formData.entity_type === 'individual' ? 'Овог нэр' : 'Байгууллагын нэр'} <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="company_name"
                    value={formData.company_name}
                    onChange={handleChange}
                    className={`admin-input ${errors.company_name ? 'border-red-300' : ''}`}
                    placeholder="жнь: Номин Express"
                    disabled={loading}
                  />
                  {errors.company_name && (
                    <p className="mt-1 text-sm text-red-600">{errors.company_name}</p>
                  )}
                </div>

                 <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Регистрийн дугаар (РД)
                  </label>
                  <input
                    type="text"
                    name="register_number"
                    value={formData.register_number}
                    onChange={handleChange}
                    className={`admin-input ${errors.register_number ? 'border-red-300' : ''}`}
                    placeholder={formData.entity_type === 'individual' ? 'ВК78120222' : '1234567'}
                    maxLength={formData.entity_type === 'individual' ? 10 : 7}
                    disabled={loading}
                  />
                  {errors.register_number && (
                    <p className="mt-1 text-sm text-red-600">{errors.register_number}</p>
                  )}
                  <p className="mt-1 text-xs text-gray-500">
                    {formData.entity_type === 'individual' 
                      ? '2 үсэг + 8 тоо (жнь: ВК78120222)' 
                      : '7 оронтой тоо'}
                  </p>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Утасны дугаар <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className={`admin-input ${errors.phone ? 'border-red-300' : ''}`}
                    placeholder="99001122"
                    maxLength="8"
                    disabled={loading}
                  />
                  {errors.phone && (
                    <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    И-мэйл хаяг
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className={`admin-input ${errors.email ? 'border-red-300' : ''}`}
                    placeholder="info@company.mn"
                    disabled={loading}
                  />
                  {errors.email && (
                    <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                  )}
                </div>

                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Хаяг
                  </label>
                  <textarea
                    name="address"
                    value={formData.address}
                    onChange={handleChange}
                    className="admin-input"
                    rows="2"
                    placeholder="УБ хот, СБД..."
                    disabled={loading}
                  />
                </div>
                {/* ============================================ */}
              {/* ШИНЭ: Агуулахын тоо */}
              {/* ============================================ */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Агуулахын дээд хязгаар <span className="text-red-500">*</span>
                </label>
                <input
                  type="number"
                  name="max_warehouses"
                  value={formData.max_warehouses}
                  onChange={handleChange}
                  className="admin-input"
                  min="1"
                  max="100"
                  placeholder="1"
                  disabled={loading}
                />
                <p className="mt-1 text-xs text-gray-500">
                  Компани хэдэн агуулах үүсгэх эрхтэй вэ (1-100)
                </p>
              </div>
                
              </div>
            </div>

             {/* ============================================ */}
            {/* ШИНЭ: Үнийн загвар & Гэрээний тохиргоо */}
            {/* ============================================ */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>📋</span>
                <span>Үнийн загвар & Гэрээ</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Үнийн загвар */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Үнийн загвар <span className="text-red-500">*</span>
                  </label>
                  <select
                    name="pricing_model"
                    value={formData.pricing_model}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="per_delivery">Нэгж хүргэлтээр</option>
                    <option value="monthly_fixed">Сарын тогтмол</option>
                    <option value="hybrid">Хосолсон (сарын + нэгжээр)</option>
                  </select>
                  <p className="mt-1 text-xs text-gray-500">
                    {formData.pricing_model === 'per_delivery' && 'Хүргэлт бүрээс шимтгэл авна'}
                    {formData.pricing_model === 'monthly_fixed' && 'Сар бүр тогтмол төлбөр төлнө'}
                    {formData.pricing_model === 'hybrid' && 'Сарын төлбөр + нэгж хүргэлтээр'}
                  </p>
                </div>

                {/* Сарын тогтмол төлбөр (monthly_fixed эсвэл hybrid үед) */}
                {(formData.pricing_model === 'monthly_fixed' || formData.pricing_model === 'hybrid') && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Сарын төлбөр (₮) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      name="monthly_fee"
                      value={formData.monthly_fee}
                      onChange={handleChange}
                      className="admin-input"
                      min="0"
                      step="1000"
                      placeholder="100000"
                      disabled={loading}
                    />
                  </div>
                )}

                {/* Нэгж шимтгэл (per_delivery эсвэл hybrid үед) */}
                {(formData.pricing_model === 'per_delivery' || formData.pricing_model === 'hybrid') && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Нэгж хүргэлтийн шимтгэл (₮) <span className="text-red-500">*</span>
                    </label>
                     <input
                      type="number"
                      name="commission_value"
                      value={formData.commission_value}
                      onChange={handleChange}
                      className={`admin-input ${errors.commission_value ? 'border-red-300' : ''}`}
                      min="0"
                      step="1"
                      placeholder="250, 500, 1000..."
                      disabled={loading}
                    />
                    {errors.commission_value && (
                      <p className="mt-1 text-sm text-red-600">{errors.commission_value}</p>
                    )}
                  </div>
                )}

                {/* Төлбөрийн давтамж */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Төлбөрийн давтамж
                  </label>
                  <select
                    name="billing_cycle"
                    value={formData.billing_cycle}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="daily">Өдөр бүр</option>
                    <option value="weekly">7 хоног бүр</option>
                    <option value="monthly">Сар бүр</option>
                  </select>
                </div>
              </div>
            </div>

            {/* ============================================ */}
            {/* ШИНЭ: Туршилтын хугацаа & Үнэгүй хүргэлт */}
            {/* ============================================ */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>🎁</span>
                <span>Туршилт & Урамшуулал</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Туршилтын хугацаа - Preset */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Туршилтын хугацаа
                  </label>
                  <select
                    name="trial_preset"
                    value={formData.trial_preset}
                    onChange={handleTrialPresetChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="0">Байхгүй</option>
                    <option value="7">7 хоног</option>
                    <option value="14">14 хоног</option>
                    <option value="30">1 сар (30 хоног)</option>
                    <option value="custom">Гараас оруулах</option>
                  </select>
                  <p className="mt-1 text-xs text-gray-500">
                    Туршилтын хугацаанд шимтгэл бодохгүй
                  </p>
                </div>

                {/* Туршилтын хугацаа - Custom */}
                {formData.trial_preset === 'custom' && (
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Хоногийн тоо
                    </label>
                    <input
                      type="number"
                      name="trial_days"
                      value={formData.trial_days}
                      onChange={handleChange}
                      className="admin-input"
                      min="1"
                      max="365"
                      placeholder="45"
                      disabled={loading}
                    />
                  </div>
                )}

                {/* Үнэгүй хүргэлтийн тоо */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Үнэгүй хүргэлтийн тоо
                  </label>
                  <input
                    type="number"
                    name="free_delivery_count"
                    value={formData.free_delivery_count}
                    onChange={handleChange}
                    className="admin-input"
                    min="0"
                    placeholder="0"
                    disabled={loading}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    Эхний X хүргэлтэд шимтгэл авахгүй (0 = хязгааргүй биш)
                  </p>
                </div>

                {/* Хямдралын хувь */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Хямдралын хувь (%)
                  </label>
                  <input
                    type="number"
                    name="discount_percent"
                    value={formData.discount_percent}
                    onChange={handleChange}
                    className="admin-input"
                    min="0"
                    max="100"
                    step="0.5"
                    placeholder="0"
                    disabled={loading}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    VIP компаниудад шимтгэлийн хямдрал
                  </p>
                </div>
              </div>
            </div>

            {/* ============================================ */}
            {/* ШИНЭ: Гэрээний хугацаа & Төлбөрийн нөхцөл */}
            {/* ============================================ */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>📄</span>
                <span>Гэрээний нөхцөл</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Гэрээ эхлэх огноо */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Гэрээ эхлэх огноо
                  </label>
                  <input
                    type="date"
                    name="contract_start_date"
                    value={formData.contract_start_date}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  />
                </div>

                {/* Гэрээ дуусах огноо */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Гэрээ дуусах огноо
                  </label>
                  <input
                    type="date"
                    name="contract_end_date"
                    value={formData.contract_end_date}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  />
                </div>

                {/* Төлбөр хийх хугацаа */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Төлбөр хийх хугацаа (хоног)
                  </label>
                  <select
                    name="payment_terms_days"
                    value={formData.payment_terms_days}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="7">7 хоног</option>
                    <option value="14">14 хоног</option>
                    <option value="30">30 хоног</option>
                    <option value="45">45 хоног</option>
                    <option value="60">60 хоног</option>
                  </select>
                  <p className="mt-1 text-xs text-gray-500">
                    Нэхэмжлэхээс хойш төлбөр хийх хугацаа
                  </p>
                </div>

                {/* Зээлийн хязгаар */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Зээлийн хязгаар (₮)
                  </label>
                  <input
                    type="number"
                    name="credit_limit"
                    value={formData.credit_limit}
                    onChange={handleChange}
                    className="admin-input"
                    min="0"
                    step="100000"
                    placeholder="0"
                    disabled={loading}
                  />
                  <p className="mt-1 text-xs text-gray-500">
                    0 = хязгааргүй
                  </p>
                </div>

                {/* Автомат сунгалт */}
                <div className="md:col-span-2">
                  <label className="flex items-center gap-3 cursor-pointer">
                    <input
                      type="checkbox"
                      name="auto_renew"
                      checked={formData.auto_renew}
                      onChange={handleCheckboxChange}
                      className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                      disabled={loading}
                    />
                    <span className="text-sm font-medium text-gray-700">
                      Гэрээ дуусахад автоматаар сунгах
                    </span>
                  </label>
                </div>

                {/* Тэмдэглэл */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Гэрээний тэмдэглэл
                  </label>
                  <textarea
                    name="contract_notes"
                    value={formData.contract_notes}
                    onChange={handleChange}
                    className="admin-input"
                    rows="3"
                    placeholder="Нэмэлт тэмдэглэл..."
                    disabled={loading}
                  />
                </div>
              </div>
            </div>

            {/* Commission - Хуучин хэсэг (статус үлдээх) */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>⚙️</span>
                <span>Бусад тохиргоо</span>
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Статус
                  </label>
                  <select
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="active">Идэвхтэй</option>
                    <option value="inactive">Идэвхгүй</option>
                    <option value="suspended">Түр хаагдсан</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Bank Account - ШИНЭ ХЭСЭГ! */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span>🏦</span>
                <span>Шимтгэл төлөх данс</span>
              </h3>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Данс сонгох
                </label>
                {loadingBanks ? (
                  <div className="admin-input bg-gray-50 flex items-center justify-center">
                    <span className="text-gray-500">Уншиж байна...</span>
                  </div>
                ) : bankAccounts.length === 0 ? (
                  <div className="admin-input bg-yellow-50 border-yellow-200">
                    <p className="text-yellow-700 text-sm">
                      ⚠️ Данс бүртгээгүй байна. Тохиргоо хэсэгт данс нэмнэ үү.
                    </p>
                  </div>
                ) : (
                  <select
                    name="system_bank_account_id"
                    value={formData.system_bank_account_id}
                    onChange={handleChange}
                    className="admin-input"
                    disabled={loading}
                  >
                    <option value="">-- Данс сонгоно уу --</option>
                    {bankAccounts.map(account => (
                      <option key={account.id} value={account.id}>
                        {account.bank_name} - {account.account_number} ({account.account_name})
                      </option>
                    ))}
                  </select>
                )}
                <p className="mt-2 text-xs text-gray-500">
                  Компани энэ данс руу шимтгэлийн төлбөрөө шилжүүлнэ
                </p>
              </div>
            </div>

            {/* Admin Info (only for new company) */}
            {!company && (
              <div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2 flex items-center gap-2">
                  <span>👤</span>
                  <span>Компанийн админ</span>
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Нэвтрэх нэр болон нууц үг <strong>автоматаар үүснэ</strong>
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Овог нэр
                    </label>
                    <input
                      type="text"
                      name="admin_full_name"
                      value={formData.admin_full_name}
                      onChange={handleChange}
                      className="admin-input"
                      placeholder="жнь: Б.Болд"
                      disabled={loading}
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Утасны дугаар
                    </label>
                    <input
                      type="text"
                      name="admin_phone"
                      value={formData.admin_phone}
                      onChange={handleChange}
                      className={`admin-input ${errors.admin_phone ? 'border-red-300' : ''}`}
                      placeholder="88001122"
                      maxLength="8"
                      disabled={loading}
                    />
                    {errors.admin_phone && (
                      <p className="mt-1 text-sm text-red-600">{errors.admin_phone}</p>
                    )}
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      И-мэйл хаяг
                    </label>
                    <input
                      type="email"
                      name="admin_email"
                      value={formData.admin_email}
                      onChange={handleChange}
                      className="admin-input"
                      placeholder="admin@company.mn"
                      disabled={loading}
                    />
                  </div>
                </div>

                <div className="mt-4 bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <p className="text-sm text-blue-800">
                    ℹ️ Админы мэдээлэл оруулаагүй бол зөвхөн компанийн утас болон и-мэйл ашиглагдана
                  </p>
                </div>
              </div>
            )}
          </div>

          {/* Actions */}
          <div className="flex gap-3 pt-6 mt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={() => onClose(false)}
              className="flex-1 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition font-medium"
              disabled={loading}
            >
              Цуцлах
            </button>
            <button
              type="submit"
              className="flex-1 btn btn-primary justify-center"
              disabled={loading}
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Уншиж байна...</span>
                </span>
              ) : (
                <span>{company ? 'Хадгалах' : 'Үүсгэх'}</span>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanyModal;